export default __webpack_public_path__ + "img/seoul_mucon_2023-ec05dcdb96919121b57cd85a607b25ae.png";